/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .trip-booking-package-card-container{width:100%;margin:8px 0 0;border-radius:8px;box-shadow:0 3px 6px 0 rgba(0,0,0,.08);background-color:#fff;overflow:hidden}"];
export { styles as styles };
